import MednarodnePodatkovneBlokade from './MednarodnePodatkovneBlokade'
import NacionalnePodatkovneBlokade from './NacionalnePodatkovneBlokade'
import BlokadaKomercialnihSporocil from './BlokadaKomercialnihSporocil'
import RoamingProfili from './RoamingProfili'
import ZaporeKlicev from './ZaporeKlicev'
import Preusmeritve from './Preusmeritve'

export default class TelefonskaStevilka {
  static instances = {}
  _idPrikljucek = null
  _stevilka = null
  _idSimKartica = null
  _mednarodnePodatkovneBlokade = null
  _nacionalnePodatkovneBlokade = null
  _blokadaKomercialnihSporocil = null
  _roamingPrifili = null
  _zaporeKlicev = null
  _preusmeritve = null

  static getInstance (idPrikljucek, stevilka, idSimKartica) {
    let instKey = `${idPrikljucek}_${stevilka}`
    if (this.instances[instKey] === undefined) {
      this.instances[instKey] = new TelefonskaStevilka(idPrikljucek, stevilka, idSimKartica)
    }
    return this.instances[instKey]
  }

  constructor (idPrikljucek, stevilka, idSimKartica) {
    this._idPrikljucek = idPrikljucek
    this._stevilka = stevilka
    this._idSimKartica = idSimKartica
    this._mednarodnePodatkovneBlokade = new MednarodnePodatkovneBlokade(idPrikljucek, stevilka)
    this._nacionalnePodatkovneBlokade = new NacionalnePodatkovneBlokade(idPrikljucek, stevilka)
    this._blokadaKomercialnihSporocil = new BlokadaKomercialnihSporocil(idPrikljucek, stevilka)
    this._roamingPrifili = new RoamingProfili(idPrikljucek, stevilka)
    this._zaporeKlicev = new ZaporeKlicev(idPrikljucek, stevilka, idSimKartica)
    this._preusmeritve = new Preusmeritve(idPrikljucek, stevilka, idSimKartica)
  }

  get idPrikljucek () {
    return this._idPrikljucek
  }

  set idPrikljucek (value) {
    this._idPrikljucek = value
  }

  get stevilka () {
    return this._stevilka
  }

  set stevilka (value) {
    this._stevilka = value
  }

  get idSimKartica () {
    return this._idSimKartica
  }

  set idSimKartica (value) {
    this._idSimKartica = value
  }

  get mednarodnePodatkovneBlokade () {
    return this._mednarodnePodatkovneBlokade
  }

  set mednarodnePodatkovneBlokade (value) {
    this._mednarodnePodatkovneBlokade = value
  }

  get nacionalnePodatkovneBlokade () {
    return this._nacionalnePodatkovneBlokade
  }

  set nacionalnePodatkovneBlokade (value) {
    this._nacionalnePodatkovneBlokade = value
  }

  get blokadaKomercialnihSporocil () {
    return this._blokadaKomercialnihSporocil
  }

  set blokadaKomercialnihSporocil (value) {
    this._blokadaKomercialnihSporocil = value
  }

  get roamingPrifili () {
    return this._roamingPrifili
  }

  set roamingPrifili (value) {
    this._roamingPrifili = value
  }

  get zaporeKlicev () {
    return this._zaporeKlicev
  }

  set zaporeKlicev (value) {
    this._zaporeKlicev = value
  }

  get preusmeritve () {
    return this._preusmeritve
  }

  set preusmeritve (value) {
    this._preusmeritve = value
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/Prikljucek/Telefonija/Umts/TelefonskaStevilka.js